"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var UIUtils_1 = require("./UIUtils");
var CryptoJS = require("crypto-js");
var webTransport = /** @class */ (function () {
    function webTransport() {
    }
    webTransport._makeUnknownError = function () {
        return {
            api: "неизвестная api",
            fail: true,
            success: false,
            error: {
                code: -1,
                info: "неизвестная ошибка api",
                reason: "неизвестная ошибка api"
            }
        };
    };
    /* public static setCurrency(currency : string) : void {
         this._currency = currency;
     }

     public static getCurrency() : string {
         return this._currency;
     }

     public static setBalance(balance : number) : void {
         this._balance = balance;
     }

     public static getBalance() : number {
         return this._balance;
     }*/
    /*private static _makeTransportError(err : string) : iErrorResp {
        return {
            api: "unknown api",
            fail: true,
            success: false,
            error: {
                code: -2,
                info: err,
                reason: "transport error"
            }
        }
    }*/
    webTransport.execAction = function (req, onSuccess, onError) {
        var _this = this;
        var xhr = new XMLHttpRequest();
        xhr.open("POST", this._url + "?_=" + UIUtils_1.UIUtils.generateUUID(), true);
        xhr.setRequestHeader('mg-login-header', this._login);
        xhr.setRequestHeader('mg-sign-header', this._sign);
        xhr.setRequestHeader('mg-pprogram-header', this._pprogram_identity);
        xhr.setRequestHeader('Content-Type', 'application/json; charset=utf-8');
        xhr.onload = function () {
            if (xhr.status === 200) {
                var response = JSON.parse(xhr.responseText);
                if (response) {
                    if (response.success) {
                        if (onSuccess !== undefined) {
                            onSuccess(response);
                        }
                    }
                    else {
                        onError(response ? response : _this._makeUnknownError());
                    }
                }
                else {
                    onError(_this._makeUnknownError());
                }
            }
            else if (xhr.status !== 200) {
                onError(_this._makeUnknownError());
                console.log("Request failed.  Returned status of  " + xhr.status);
            }
        };
        xhr.onerror = function (error) {
            onError(_this._makeUnknownError());
            console.log("Request failed. (on error)");
        };
        xhr.send(JSON.stringify(req));
    };
    webTransport.setPProgramIdentity = function (identity) {
        this._pprogram_identity = identity;
    };
    webTransport.getPProgramIdentity = function () {
        return this._pprogram_identity;
    };
    webTransport.setIsLogged = function (logged) {
        this._isLogged = logged;
    };
    webTransport.isLogged = function () {
        return this._isLogged;
    };
    webTransport.setUrl = function (url) {
        this._url = url;
    };
    webTransport.getUrl = function () {
        return this._url;
    };
    webTransport.setLang = function (lang) {
        this._lang = lang;
    };
    webTransport.getLang = function () {
        return this._lang;
    };
    webTransport.setLogin = function (login) {
        this._login = login;
    };
    webTransport.getLogin = function () {
        return this._login;
    };
    webTransport.setSign = function (sign) {
        this._sign = sign;
    };
    webTransport.getSign = function () {
        return this._sign;
    };
    webTransport.setLoginKey = function (key) {
        this._loginKey = key;
    };
    webTransport.getLoginKey = function () {
        return this._loginKey;
    };
    webTransport.clearAuthData = function () {
        this._login = '';
        this._sign = '';
        this._loginKey = '';
        this._isLogged = false;
    };
    webTransport.calcSign = function (LoginKey, Login, Password) {
        var _Hash = CryptoJS.HmacSHA1("" + Login + Password + LoginKey, LoginKey);
        return _Hash.toString(CryptoJS.enc.Base64);
    };
    webTransport.calcPassSign = function (Password) {
        var _Hash = CryptoJS.HmacSHA1(Password, this._sign);
        return _Hash.toString(CryptoJS.enc.Base64);
    };
    webTransport._url = "";
    webTransport._login = "";
    webTransport._sign = "";
    webTransport._loginKey = "";
    webTransport._isLogged = false;
    webTransport._lang = "ru";
    webTransport._pprogram_identity = "";
    return webTransport;
}());
exports.webTransport = webTransport;



//////////////////
// WEBPACK FOOTER
// ./src/shared/modules/webTransport.ts
// module id = 164
// module chunks = 0